/**
 * 표준(기준) 요율 — 정부 고시/업계 표준값. 사용자는 여기서 미세조정합니다.
 * 추후 연도/공사유형별 세트가 생기면 이 값을 서버에서 불러와 교체하면 됩니다.
 */
export const STANDARD_RATES = {
  indirectMaterial: 0.0282, // 간접재료비: 직접재료비 ×
  indirectLabor: 0.175, // 간접노무비: 직접노무비 ×
  generalAdmin: 0.08, // 일반관리비: 계 ×
  profit: 0.15, // 이윤: (노무+경비+일반관리비) ×
  vat: 0.1, // 부가가치세: 공급가액 ×
};

/** 경비 항목별 표준 요율 (id 기준) */
export const STANDARD_EXPENSE_RATES = new Map<string, number>([
  ["exp-sanjae", 0.0356], // 산재보험료
  ["exp-goyong", 0.0101], // 고용보험료
  ["exp-seokmyeon", 0.00006], // 석면분담금
  ["exp-imgeum", 0.0009], // 임금채권부담금
  ["exp-gita", 0.05], // 기타경비
  ["exp-hwangyeong", 0.003], // 환경보전비
]);
